import { createSlice } from "@reduxjs/toolkit";

const marketGroup = {};
const marketGroupForDashboard = [];
// const groupFiltersData = [];

const MarketGroupSlice = createSlice({
    name: "MarketGroup",
    initialState: {
        marketGroup,
        marketGroupForDashboard,
        // groupFiltersData
    },
    reducers: {
        reSetMarketGroup(state, action){
            state.marketGroup = {}
        },
        setMarketGroup(state, action) {
            state.marketGroup = action.payload;
        },
        // setGroupFiltersData(state, action) {
        //     state.groupFiltersData = action.payload;
        // },
        setMarketGroupForDashboard(state, action) {
            state.marketGroupForDashboard = action.payload;
        },
    },
});


export const {
    setMarketGroup,
    reSetMarketGroup,
    setMarketGroupForDashboard,
    // setGroupFiltersData
} = MarketGroupSlice.actions;

export default MarketGroupSlice.reducer;
